import { atom } from 'jotai';
import { pendingQueue } from 'shared/utils/pending-queue';
import { User } from 'shared/models/legacy';
import { PromiseOrValue } from 'shared/utils/promise-or-value';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

type TUserRelatedUserStore = { [key: string]: PromiseOrValue<User[]> | undefined };

export const $UserRelatedStore = atom({} as TUserRelatedUserStore);

export const $UserRelatedUser = safeAtomFamily((userLinkName: string) => {
  const a = atom(
    (get) => {
      const data = get($UserRelatedStore)[userLinkName];
      if (!data) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw new Promise((resolve) => pendingQueue.push(resolve));
      }
      return data;
    },
    (get, set, input: User[]) => {
      const old = get($UserRelatedStore);
      set($UserRelatedStore, { ...old, [userLinkName]: input });
    },
  );

  a.debugLabel = `$UserRelatedUser+${encodeURIComponent(userLinkName)}`;

  return a;
});
